











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'
import {CargaDestinatarioCollection} from '@/model/collection/CargaDestinatarioCollection'
import {ListCargaDestinatarioSchema} from '@/schema/resource/CargaDestinatario/ListCargaDestinatarioSchema'
import {CsvCargaDestinatarioSchema} from '@/schema/resource/CargaDestinatario/CsvCargaDestinatarioSchema'

@Component
export default class ListCargaDestinatarioView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListCargaDestinatarioSchema()
  collection = new CargaDestinatarioCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaDestinatario) {
    Helper.pushByName(
      'editCargaDestinatario',
      item.idCargaFk,
      item.idEnderecoFk
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaDestinatarioCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvCargaDestinatario()
    new CsvCargaDestinatarioSchema().downloadCsv(csv.all())
  }
}
